export default (theme) => ({
  hero: {
    color: theme.colors[1],
  },
  [theme.mediaInverse.sm]: {
    wrapper: {
      paddingTop: 100,
    },
  },
})
